
import React, { memo, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { IconButton, LinearProgress, makeStyles } from '@material-ui/core';
import { Typography } from 'components/ui';
import theme from 'theme';
import PublishIcon from '@material-ui/icons/Publish';
import { StyledDialog } from 'components';
import ImageIcon from '@material-ui/icons/Image';
import ClearIcon from '@material-ui/icons/Clear';
import Zoom from '@material-ui/core/Zoom';
import CloseIcon from '@material-ui/icons/Close';
import combineClx from 'utils/combineClx';
import TakePhotoWebCam from 'components/TakePhotoWebCam';

const styles = {
    progressWrapper: {
        height: '40px',
        // width: '245px',
        width: '100%',
        float: 'left',
        overflow: 'hidden',
        // backgroundColor: 'rgb(245, 245, 245)',
        // color: '#fff',
        // fontFamily: 'Avenir',
        cursor: 'pointer',
        textAlign: 'center',
        border: '1px solid #D2E8F1',
        borderRadius: '100px',
    },
    progressBar: {
        // float: 'left',
        width: '0',
        height: '100%',
        // color: '#fff',
        textAlign: 'center',
        backgroundColor: '#D2E8F1',
        // WebkitBoxShadow: 'inset 0 -1px 0 rgba(0,0,0,.15)',
        // boxShadow: 'inset 0 -1px 0 rgba(0,0,0,.15)',
        WebkitTransition: 'width .6s ease',
        Otransition: 'width .6s ease',
        transition: 'width .6s ease',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    cancelButton: {
        marginTop: '-5px',
        WebkitAppearance: 'none',
        cursor: 'pointer',
        background: '0 0',
        border: 0,
        // float: 'left',
        fontSize: '21px',
        fontWeight: 700,
        lineHeight: 1,
        color: '#000',
        textShadow: '0 1px 0 #fff',
        filter: 'alpha(opacity=20)',
        opacity: '.2',
        padding: '8px',
    },
    centerFix: {
        paddingTop: theme.spacing(0.625)
    }
};

const useStyles = makeStyles((theme) => ({
    imgDiv: {
        height: theme.spacing(36.875),
        width: theme.spacing(39.875),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: "#EFF7FA",
        borderRadius: theme.spacing(2.2),
        border: `1px solid ${theme.palette.accent.main} `,
        margin: theme.spacing(3, 0, 3, 0),
    },

    document_img: {
        height: theme.spacing(29.875),
        width: theme.spacing(35.375),

    },
    space: {
        width: theme.spacing(1),
        [theme.breakpoints.down(theme.showDrawerBreakPointUp)]: {
            height: theme.spacing(1),
        }
    },
    columnWiseSpace: {
        height: theme.spacing(1),
    },
    uploadDivColumnWise: {
        margin: theme.spacing(3, 0, 6, 0),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-around',
        [theme.breakpoints.down(theme.showDrawerBreakPointUp)]: {

            alignItems: 'initial',
            justifyContent: 'initial',
        }
    },
    uploadDiv: {
        margin: theme.spacing(3, 0, 6, 0),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        [theme.breakpoints.down(theme.showDrawerBreakPointUp)]: {
            flexDirection: 'column',
            alignItems: 'initial',
            justifyContent: 'initial',
        }
    },
    previewDiv: {
        display: 'flex',
        margin: theme.spacing(2),
        flexDirection: 'column'
    },
    fileName: {
        color: theme.palette.accent.main
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: theme.spacing(1)
    },
    imgIcon: {
        color: theme.palette.accent.main,
        fontSize: theme.spacing(3),
        marginRight: theme.spacing(1.2)
    },
    rootDiv: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },

    closeIcon: {
        marginLeft: theme.spacing(1),
        padding: '0px !important'
    },
    crossIcon: {
        padding: theme.spacing(0, 0, 0, 1)
    },
    selectedFileStyle: (props) => ({
        flex: 1, display: 'flex', alignItems: 'center',
        width: props && props.props.columnWise ? '70%' : 'auto',
        '& div': {
            flex: 1,
        }

    }),
    unSelectedFileColumnWise: {
        flex: 1, width: '70%'
    },
    unSelectedFile: { flex: 1 },
    removeFlex: {
        flex: '0 !important',
    },
    iremoveFlex: {
        flex: 'none !important',
        color: theme.palette.accent.main,
    },
    fileIcon: {
        color: theme.palette.accent.main,
        marginRight: theme.spacing(1)
    },
    uploadDocTxt: {
        flex: 'auto !important',
        marginLeft: theme.spacing(1)
    }
}));

function AddressProofUpload(props = {}) {
    const { onChange = () => null, value, id, previewUrl, name, required,
        disabled, btnName, label, addressError, hintText, uploadError,
        uploadLoading,
        className = {}, columnWise = false
    } = props;

    const [takenPhoto, setTakenPhoto] = useState("");
    const [selectedFile, setSelectedFile] = useState({});
    const [error, setError] = useState(addressError);
    const classes = useStyles({ props });
    const inputRef = useRef(null);
    // eslint-disable-next-line no-unused-vars
    const [openSelectDialog, setOpenSelectDialog] = useState(false);
    // eslint-disable-next-line no-unused-vars

    useEffect(() => {
        setError(addressError);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addressError]);

    const onInvalid = (e) => {
        e.preventDefault && e.preventDefault();
        setError(false);
        setTimeout(() => {
            setError(true);
            if (props && props.onFocusRef) {
                props.onFocusRef(props.name, props.id);
            }

        }, 300);
    };

    const onFileChange = (e) => {
        setError(false);
        const { files } = e.target || {};

        const file = (files && files[0]) || {};
        onChange(e); // to clear the error;
        setSelectedFile(file);

        if (file.name) {
            // uploadHandler(e);
            if (inputRef && inputRef.current) {
                inputRef.current.value = '';
            }
        }
    };

    const onFileChangeTakePhoto = (e, cb = () => null) => {
        // eslint-disable-next-line no-unused-vars
        const { name, value, file } = e.target || {};
        setError(false);
        onChange && onChange({ target: { name, files: [file] }});
        setTakenPhoto(value);
        cb();
    };

    const onCancelImg = () => {
        onFileChangeTakePhoto({ target: {} });
        onChange({ target: { name, files: [] }});
        setTakenPhoto('');
        setSelectedFile({});
        setOpenSelectDialog(false);
    };

    // const onClearImg = () => {
    //     setSelectedFile({});
    //     onFileChange({}, () => null);
    // };

    const disabledStyle = props.disabled ? {
        backgroundColor: 'rgb(242, 242, 243)',
        border: '1px solid rgb(203, 203, 203)',
        color: '#545454',
        cursor: 'no-drop',
    } : {};
    const style = {
        // height: '28px',
        // width: '245px',
        // fontFamily: 'Avenir',
        cursor: 'pointer',
        textAlign: 'center',

    };

    if (takenPhoto) {
        return <div style={{marginBottom: '24px'}}><Zoom in={takenPhoto ? true : false} >
            <div className={classes.rootDiv} >
                <div className={classes.imgDiv} >
                    <div className={classes.previewDiv} >
                        <img alt="document" className={classes.document_img} src={takenPhoto} />
                        <div className={classes.row} >
                            <ImageIcon className={classes.imgIcon} />
                            <Typography variant="body1" className={classes.fileName} >{label}</Typography>
                        </div>
                    </div>

                </div>
                <IconButton disabled={uploadLoading} className={classes.closeIcon} onClick={onCancelImg} >
                    <ClearIcon />
                </IconButton>
            </div>
        </Zoom>
        {uploadLoading ? <div style={{ margin: '0 auto', width: columnWise ? "70%" : undefined}}><LinearProgress color='secondary' /></div> : null}
        {uploadError ? <div style={{textAlign: 'center', color: '#e32e21'}}>{uploadError}</div> : null}
        </div>
    }

    return (
      <>
        {previewUrl && takenPhoto ? (
          <></>
        ) : (
          <div
            className={
              columnWise
                ? combineClx(classes.uploadDivColumnWise, className)
                : combineClx(classes.uploadDiv, className)
            }
          >
            <div
              className={
                selectedFile && selectedFile.name
                  ? classes.selectedFileStyle
                  : columnWise
                  ? classes.unSelectedFileColumnWise
                  : classes.unSelectedFile
              }
            >
              {selectedFile && selectedFile.name && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography variant="subtitle1">{selectedFile.name}</Typography>
                    <IconButton
                      disabled={uploadLoading}
                      className={classes.crossIcon}
                      onClick={onCancelImg}
                    >
                      <div
                        style={{
                          alignSelf: "center",
                          textAlign: "right",
                          justifySelf: "right",
                          flex: 1,
                        }}
                      >
                        <CloseIcon
                          style={{ ...styles.centerFix, paddingRight: "6px" }}
                        />
                      </div>
                    </IconButton>
                  </div>
                  <Typography variant="body1" style={{textAlign: 'center'}}>{label}</Typography>
                  {uploadLoading ? <div style={{ margin: '0 auto', width: columnWise ? "70%" : undefined}}><LinearProgress color='secondary' /></div> : null}

                  {uploadError ? (
                    <div style={{ textAlign: "center", color: "#e32e21" }}>
                     {uploadError}
                    </div>
                  ) : null}
                </div>
              )}
            </div>
            {selectedFile && selectedFile.name ? (
              <></>
            ) : (
              <>
                <StyledDialog
                  open={openSelectDialog}
                  noFullScreen
                  triggerComponent={(onOpen) => (
                    <div
                      onClick={onOpen}
                      style={{ flex: 1, width: columnWise ? "70%" : undefined }}
                    >
                      <div
                        style={{
                          ...style,
                          ...{
                            cursor: "pointer",
                            textAlign: "center",
                            color: "#1e1e1e",
                            padding: error ? "5px" : "3px",
                            borderRadius: "100px",
                            border: error
                              ? "1px solid #e32e21"
                              : "2px solid #1e1e1e",
                            display: "flex",
                            height: theme.spacing(5.5),
                            alignItems: "center",
                            justifyContent: "center",
                          },
                          ...disabledStyle,
                        }}
                      >
                        <Typography variant="button">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div>
                              <PublishIcon />
                            </div>
                            <div className={classes.uploadDocTxt}>
                              {btnName}
                            </div>
                          </div>
                        </Typography>
                      </div>
                      <Typography variant="caption" color="grey500">
                        {hintText}
                      </Typography>
                    </div>
                  )}
                  closeIcon={true}
                  onClose={() => setOpenSelectDialog(false)}
                  childComponent={(onClose) => (
                    <div style={{ margin: "24px" }}>
                      <div style={{ flex: 1 }}>
                        <input
                          id={`input_file_${id}`}
                          style={{ display: "none" }}
                          type="file"
                          onChange={(e) => {
                            onFileChange(e, () => null);
                          }}
                          name={name}
                          required={!value && required}
                          // required={required}
                          disabled={disabled}
                          onInvalid={onInvalid}
                          ref={inputRef}
                        />
                        <div style={{ flex: 1 }}>
                          <label
                            style={{
                              ...style,
                              ...{
                                cursor: "pointer",
                                textAlign: "center",
                                color: "#1e1e1e",
                                padding: error ? "5px" : "3px",
                                borderRadius: "100px",
                                border: error
                                  ? "1px solid #e32e21"
                                  : "2px solid #1e1e1e",
                                display: "flex",
                                height: theme.spacing(5.5),
                                alignItems: "center",
                                justifyContent: "center",
                              },
                              ...disabledStyle,
                            }}
                            htmlFor={`input_file_${id}`}
                          >
                            <Typography variant="button">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div>
                                  <PublishIcon />
                                </div>
                                <div className={classes.uploadDocTxt}>
                                  {"Upload a File"}
                                </div>
                              </div>
                            </Typography>
                          </label>
                        </div>
                      </div>
                      <div style={{ textAlign: "center", margin: "8px" }}>
                        <Typography variant="subtitle1">OR</Typography>
                      </div>
                      {/* <div className={classes.columnWiseSpace} />
                                            <div className={classes.columnWiseSpace} /> */}
                      <TakePhotoWebCam
                        columnWise={columnWise}
                        id={id}
                        error={error}
                        btnName={"Take a photo"}
                        required
                        name={name}
                        // onChange={(e) => { onFileChangeTakePhoto(e, id, onClose) }}
                        onChange={(e) => {
                          onFileChangeTakePhoto(e, onClose);
                        }}
                        // documentUploadState={documentUploadState}
                        // documentUpload={documentUpload}
                        // resetDocumentUpload={resetDocumentUpload}
                      />
                    </div>
                  )}
                />
              </>
            )}
          </div>
        )}
      </>
    );
};


const mapStateToProps = createStructuredSelector({

});

function mapDispatchToProps(dispatch) {
    return {

    }
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export default compose(
    withConnect,
    memo,
)(AddressProofUpload);